import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import React from 'react';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { Section } from '../../Section';
import { ArticleCard } from '../ArticleCard';
export var ProductArticles = function ProductArticles(_ref) {
  var product = _ref.product,
    articles = _ref.articles,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin;
  var items = articles.items;
  if (items.length === 0) {
    return null;
  }
  var title = "\xDAltimos art\xEDculos de ".concat(items[0].author.displayName);
  var link = {
    text: "Todos los art\xEDculos de ".concat(items[0].author.displayName),
    href: getSuperPartnerBaseURL() + items[0].author.web
  };
  return React.createElement(Section, {
    title: title,
    link: link,
    bottomMargin: bottomMargin
  }, items.slice(0, 5).map(function (article) {
    return React.createElement(ArticleCard, {
      key: article.id,
      withAuthor: false,
      variant: "small",
      article: article,
      withImage: true,
      dataFiEvent: "product-articleGroup"
    });
  }));
};